import React from 'react';
import {Grid} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Grid)(() => ({
  position: 'relative',
  padding: '1em',
}))

type CollapsableCardBodyContainerProps = React.ComponentPropsWithoutRef<'div'>

/**
 * MUI Grid component styled in the SecurSpace way. To be used in the CollapseContainer of the Collapsable Card suite of components
 * @param children children passed through to the internal Grid component
 * @param rest The rest of the Grid props that will be passed through to the internal Grid component
 * @constructor
 */
const CollapsableCardBodyContainer = ({children, ...rest}: CollapsableCardBodyContainerProps) => {
  return <Root container alignItems={'flex-start'} sx={{ mx: -0.5, '& > *': {px: 0.5 } }} {...rest}>
    { children }
  </Root>
}

export { CollapsableCardBodyContainer };
